import { render } from "./MoveColis.vue?vue&type=template&id=43e7a642&ts=true"
import script from "./MoveColis.vue?vue&type=script&lang=ts"
export * from "./MoveColis.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__